import {
  BadgeCheck,
  Bell,
  Layers,
  LayoutDashboard,
  PawPrint,
  Store,
  Users,
} from "lucide-react";
import type { ComponentType } from "react";

export interface NavItem {
  label: string;
  to: string;
  icon: ComponentType<{ className?: string }>;
  /** Any one of these permits the item. */
  permissions: string[];
  /** Key on the badge-counts payload, when the item shows a pending count. */
  countKey?: string;
  /** Matches nested routes for active state. */
  matchPrefix?: boolean;
}

export interface NavSection {
  label: string;
  items: NavItem[];
}

export const NAV: NavSection[] = [
  {
    label: "Overview",
    items: [
      {
        label: "Dashboard",
        to: "/",
        icon: LayoutDashboard,
        permissions: ["*"],
      },
    ],
  },
  {
    label: "Management",
    items: [
      {
        label: "Users & Buyers",
        to: "/users",
        icon: Users,
        permissions: ["*"],
        matchPrefix: true,
      },
      {
        label: "Breeders",
        to: "/breeders",
        icon: Store,
        permissions: ["*"],
        matchPrefix: true,
      },
      {
        label: "Pet Listings",
        to: "/listings",
        icon: PawPrint,
        permissions: ["*"],
        matchPrefix: true,
      },
      {
        label: "Verification Requests",
        to: "/verification",
        icon: BadgeCheck,
        permissions: ["*"],
        countKey: "pending_verifications",
      },
      {
        label: "Plans & Subscriptions",
        to: "/plans",
        icon: Layers,
        permissions: ["*"],
        matchPrefix: true,
      },
      {
        label: "Broadcast Notifications",
        to: "/broadcast",
        icon: Bell,
        permissions: ["*"],
        matchPrefix: true,
      },
    ],
  },
];
